export class CommonResponseCodes {
  // Copied from nodejs-common
  public static readonly RAW_RESPONSE: number = -1;
  public static readonly OK: number = 0;
  public static readonly NOT_EXISTS: number = 400;
  public static readonly FORBIDDEN: number = 478;
  public static readonly NOT_AUTHORIZED: number = 503;
  public static readonly INVALID_REQUEST: number = 702;
  public static readonly INVALID_RESPONSE: number = 703;
  public static readonly CLIENT_TIMEOUT: number = 998;
  public static readonly SERVER_ERROR: number = 999;
  public static readonly DATABASE_ERROR: number = 1000;
  public static readonly CRON_ERROR: number = 990;
  public static readonly DATA_NOT_MODIFIED: number = 2401;
  public static readonly MOCK_ERROR: number = 1234567890;
  public static readonly TOO_MANY_REQUESTS: number = 1005;
  public static readonly INVALID_SHARD_ID: number = 8000;
  public static readonly NOT_ENOUGH_PERMISSIONS: number = 1006;
}

export interface StandardRequest {
  version: string;
  deviceId: string;
  device_account_id: string;
  deviceType: string;
  device_name: string;
  device_os_version: string;
  country: string;
  language: string;
  gps_lat?: number;
  gps_lng?: number;
  session_id?: string;
}

export interface ValidatorResult {
  type?: string;
  property?: string | number;
  error: string;
  children?: ValidatorResult[];
}

export interface ResponseBase {
  code: number;
  message: string;
}

export interface ErrorResponse extends ResponseBase {
  __tsTag?: 'Error';
  error_hint?: string;
  debug_id?: string;
  error_data?: {
    text?: string;
  };
}

export interface ValidationErrorResponse extends ErrorResponse {
  validation_errors: ValidatorResult[];
}

export interface SuccessResponse<T> extends ResponseBase {
  __tsTag?: 'Success';
  data: T;
}

export declare type ResponseObject<T> =
  | SuccessResponse<T>
  | ErrorResponse
  | ValidationErrorResponse;
